import axios from "axios";
import slugify from "slugify";
import { Env } from "../../../../../env";

// Singleton - Manages file uploads to S3
let instance = null;

class Uploader {
  constructor() {
    if (!instance) {
      instance = this;
    }
    return instance;
  }

  _getUploadPolicy(format, userId, accessToken) {
    try {
      var token = accessToken;
      return axios.get(
        Env.BASE_API_URL +
          "/accounts/" +
          userId +
          "/getUploadPolicy?format=" +
          format +
          "&access_token=" +
          token
      );
    } catch (e) {
      console.error("_getUploadPolicy error", e);
    }
  }

  _uploadBlobToS3(blob, policy) {
    console.log("asdds", blob);
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      console.info("PUTting:", policy.signed_request, policy);
      xhr.open("PUT", policy.signed_request);
      xhr.setRequestHeader("x-amz-acl", "public-read");
      xhr.onload = function () {
        if (xhr.status === 200) {
          console.log("url++++++++++++", policy.url);
          resolve(policy.url);
        } else {
          reject(xhr.status);
        }
      };
      xhr.onerror = function () {
        reject("Could not upload file.");
      };
      xhr.send(blob);
    });
  }

  async _createVideoWithFile(
    fileName,
    userId,
    categoryId,
    fileUrl,
    accessToken,
    posterImage
  ) {
    fileName = fileName ? fileName.split(".")[0] : "Votre vidéo";
    let slug = slugify(fileName, {
      replacement: "_",
      lower: true,
    });
    let videoData = {
      videoTitle: fileName,
      slug: slug,
      description: "Vidéo mise en ligne par vous-même",
      categoryId: categoryId,
      ownerId: userId,
      file: fileUrl,
      posterImage: posterImage || null,
    };
    const response = await axios.post(
      Env.BASE_API_URL + "/videos?access_token=" + accessToken,
      videoData
    );
    return response;
  }

  async _generateThumbnail(fileUrl, accessToken) {
    const response = await axios.post(
      `${Env.BASE_API_URL}/Videos/generateThumbnail?access_token=${accessToken}`,
      { fileUrl }
    );
    return response.data.thumbnail;
  }

  async upload(format, blob, userId, categoryId, accessToken) {
    let fileName = blob.name || "Video perso";
    let response = await this._getUploadPolicy(format, userId, accessToken);
    let fileUrl = await this._uploadBlobToS3(blob, response.data);
    const posterImage = await this._generateThumbnail(fileUrl, accessToken);

    let result = await this._createVideoWithFile(
      fileName,
      userId,
      categoryId,
      fileUrl,
      accessToken,
      posterImage
    );
    return result;
  }
}

export default new Uploader();



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/video-chooser/uploader.js